<!--
 * $Description:空白内容占位
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年05月29日 10:43:18 +0800
 * @最后修改时间: 2021-12-20 18:07:51
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_noContent.vue
-->
<template>
  <v-container
    class="
      max-width
      d-flex
      flex-grow-1
      ma-0
      pa-0
      flex-column
      justify-center
      text-center
      body-2
      align-center align-self-center
    "
    :style="{ height: (height ? height : 256) + 'px' }"
    :elevation="0"
    fluid
    color="text--secondary text--lighten-1  "
  >
    <div>
      <svg-icon size="100" iconClass="empty" />
      <div class="text-h6 mt-n4 text--secondary">
        <v-progress-circular
          v-if="isLoading"
          indeterminate
          color="grey"
          size="16"
          width="1"
        ></v-progress-circular>
        <span>{{ isLoading ? $t(data_loading_text) : $t(no_data_text) }}</span>
      </div>
      <v-btn
        rounded
        shaped
        outlined
        small
        color="primary"
        class="my-1"
        v-if="reloadBtn"
        @click="$emit('reload')"
        >{{ $t(reloadBtn) }}</v-btn
      >
    </div>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "noContent",
  props: {
    height: { default: undefined, type: [String, Number] },
    no_data_text: {
      default: "message_essweb_system_tips_emptyLabel",
      type: String,
    },
    data_loading_text: {
      default: "message_essweb_system_tips_loadingLabel",
      type: String,
    },
    reloadBtn: {
      default: null,
      type: [String, Number, Object],
    },
  },
  computed: {
    ...mapGetters(["isLoading"]),
  },
  data() {
    return {};
  },
};
</script>
